(function () {
  document.addEventListener(
    'turbo:load',
    function (event) {
      ga('send', 'pageview', window.location.pathname);
    },
    true,
  );
})();
